import React from 'react';
import { PlusIcon, ArrowRightIcon } from 'lucide-react';
import { Product } from '../types';
import { RDGuidanceBadge } from './RDGuidanceBadge';
interface ProductCardProps {
  product: Product;
  onAdd: (product: Product) => void;
  onSwap?: (currentProduct: Product, alternativeId: string) => void;
  allProducts?: Product[];
}
export function ProductCard({
  product,
  onAdd,
  onSwap,
  allProducts
}: ProductCardProps) {
  const alternative = product.healthierAlternative && allProducts ? allProducts.find(p => p.id === product.healthierAlternative) : null;
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow" data-id="element-52">
      <div className="relative" data-id="element-53">
        <img src={product.image} alt={product.name} className="w-full h-40 object-cover" data-id="element-54" />
        {product.rdRecommendation && product.rdRecommendation !== 'neutral' && <div className="absolute top-2 left-2" data-id="element-55">
            <RDGuidanceBadge recommendation={product.rdRecommendation} size="sm" data-id="element-56" />
          </div>}
      </div>

      <div className="p-3" data-id="element-57">
        <h3 className="font-semibold text-gray-900 text-sm mb-1" data-id="element-58">
          {product.name}
        </h3>
        <div className="flex items-baseline gap-2 mb-2" data-id="element-59">
          <p className="text-lg font-bold text-green-600" data-id="element-60">
            ${product.price.toFixed(2)}
          </p>
          <p className="text-xs text-gray-500" data-id="element-61">{product.size}</p>
        </div>

        {product.rdNote && <div className={`rounded-lg p-2 mb-3 border ${product.rdRecommendation === 'recommended' ? 'bg-green-50 border-green-200' : product.rdRecommendation === 'limit' ? 'bg-amber-50 border-amber-200' : 'bg-gray-50 border-gray-200'}`} data-id="element-62">
            <p className={`text-xs leading-relaxed ${product.rdRecommendation === 'recommended' ? 'text-green-800' : product.rdRecommendation === 'limit' ? 'text-amber-800' : 'text-gray-700'}`} data-id="element-63">
              {product.rdNote}
            </p>
          </div>}

        {alternative && onSwap && <button onClick={() => onSwap(product, alternative.id)} className="w-full bg-purple-100 hover:bg-purple-200 text-purple-700 font-medium py-2 px-4 rounded-full flex items-center justify-center gap-2 transition-colors mb-2" data-id="element-64">
            <span className="text-sm" data-id="element-65">Swap for {alternative.name}</span>
            <ArrowRightIcon className="w-4 h-4" data-id="element-66" />
          </button>}

        <button onClick={() => onAdd(product)} className="w-full bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-full flex items-center justify-center gap-2 transition-colors" data-id="element-67">
          <PlusIcon className="w-4 h-4" data-id="element-68" />
          <span data-id="element-69">Add to Cart</span>
        </button>
      </div>
    </div>;
}